// extracted by mini-css-extract-plugin
export var backdrop = "_go-1";
export var dragging = "_go-4";
export var handle = "_go-6";
export var handleHit = "_go-5";
export var listEnd = "_go-8";
export var modalRoot = "_go-0";
export var sectionHeader = "_go-a";
export var sheet = "_go-3";
export var sheetHost = "_go-2";
export var shortcutColumns = "_go-7";
export var shortcutSection = "_go-9";